import { PureComponent } from 'react'

import { ReplaceControl } from './replace_control'
import { UploadControl } from './upload_control'

export class ControlBlock extends PureComponent {
  render() {
    if (this.props.imageExists) {
      return (
        <ReplaceControl
          onFileSelect={this.props.onFileSelect}
          onFileError={this.props.onFileError}
          onRemove={this.props.onImageRemove}
          isAdminIA={this.props.isAdminIA}
        />
      )
    }

    return (
      <UploadControl
        onFileSelect={this.props.onFileSelect}
        onFileError={this.props.onFileError}
        isAdminIA={this.props.isAdminIA}
      />
    )
  }
}
